import { fetchData, ENDPOINT_HOST } from './api_helper';
import store from '@/store/store';

const apiURL = `${ENDPOINT_HOST}`;

const fetchLocations = (siteId, pageIndex, orderInfo) => new Promise(((resolve, reject) => {
  let endpointURL = `${apiURL}partners/${siteId}/locations?page=${pageIndex}`;
  if (orderInfo) {
    endpointURL = `${apiURL}partners/${siteId}/locations?page=${pageIndex}&order=${orderInfo.order}&direction=${orderInfo.direction}`;
  }
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchLocation = (partnerId, siteId, id) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}partners/${partnerId}/sites/${siteId}/locations/${id}`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const updateLocation = (partnerId, siteId, id, params) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}partners/${partnerId}/sites/${siteId}/locations/${id}`;
  fetchData(endpointURL, 'put', params, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const createLocation = (siteId, params) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}partners/${siteId}/locations`;
  fetchData(endpointURL, 'post', params, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const deleteLocation = (partnerId, siteId, id) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}partners/${partnerId}/sites/${siteId}/locations/${id}`;
  fetchData(endpointURL, 'delete', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));


export default {
  fetchLocations,
  fetchLocation,
  updateLocation,
  createLocation,
  deleteLocation,
};



// WEBPACK FOOTER //
// ./src/api/locations.js